import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { autoCompleteDelay } from '../../config';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, FetchAutoCompleteData, convertToNumber, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { AutoCompleteBox, FormButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const UserMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const GetGroupName = DropDownData('GetGroupName')
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        userCode: 'System Generated',
        userName: '',
        password: '',
        address: '',
        groupName: '',
        mobileNo: '',
        emailID: '',
        pinCode: '',
        city: '',
        active: true
    });

    const getUserMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/User/ShowUserMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            userCode: 'System Generated',
            userName: '',
            password: '',
            address: '',
            groupName: '',
            mobileNo: '',
            emailID: '',
            pinCode: '',
            city: '',
            active: true
        });
        filterData.SearchText = '';
        getUserMasterData();
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/InsertUpdateUserMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/User/EditUserMaster`, { UserID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else if (editData.status === 'SUCCESS') {
            setFormData((pre) => ({
                ...pre, ...editData, groupName: editData.userGroupID
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/User/DeleteUserMaster`, { UserID: id }, getUserMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    const handleChange1 = (event, value) => {
        getUserMasterData(value);
    };
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    useEffect(() => {
        getUserMasterData()
        document.title = 'User Master'
        inputrefs.current['txtUserName'].focus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortConfig])


    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'User Master'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <InputBox
                                id="txtUserCode"
                                type="text"
                                label='User Code'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtUserName'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                placeholder='System Generated'
                                name='UserCode'
                                value={formData.userCode}
                                disabled
                            />
                            <InputBox
                                id="txtUserName"
                                type="text"
                                label='User Name'
                                required={true}
                                placeholder="User Name"
                                maxLength='30'
                                value={formData.userName}
                                onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPassword'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                id="txtPassword"
                                type="password"
                                placeholder="Password"
                                label={'Password'}
                                required={true}
                                value={formData.password}
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtGroupName'].focus()
                                    }
                                }}
                            />
                            <SelectInputBox
                                id="txtGroupName"
                                value={formData.groupName}
                                label='Group Name'
                                required={true}
                                onChange={(e) => setFormData({ ...formData, groupName: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtMobileNo'].focus()
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {GetGroupName?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>

                            <InputBox
                                id="txtMobileNo"
                                placeholder="Mobile Number"
                                autoComplete="off"
                                maxLength='10'
                                required={true}
                                label='Mobile No'
                                value={formData.mobileNo}
                                onChange={(e) => setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailID'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                type="email"
                                id="txtEmailID"
                                label='Email ID'
                                required={true}
                                placeholder="Email ID"
                                maxLength='50'
                                name='EmailId'
                                value={formData.emailID}
                                onChange={(e) => setFormData({ ...formData, emailID: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                type="text"
                                id="txtAddress"
                                className="form-control"
                                placeholder="Address"
                                label='Address'
                                maxLength='200'
                                value={formData.address}
                                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPinCode'].focus()
                                    }
                                }}
                            />
                            <AutoCompleteBox
                                label='Pin Code'
                                placeholder='Pin Code'
                                inputValue={formData.pinCode ? formData.pinCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetPinCode');
                                        setFormData({ ...formData, pinCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                //required={true}
                                inputrefs={inputrefs}
                                id='txtPinCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtCity'].focus() };
                                }}
                            />
                            <AutoCompleteBox
                                label='City'
                                placeholder='City'
                                inputValue={formData.city ? formData.city : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.city, 'GetCity_PinCodeWise');
                                        setFormData({ ...formData, city: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                //required={true}
                                inputrefs={inputrefs}
                                id='txtCity'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtActive'].focus() };
                                }}
                            />
                            <Switch
                                inputrefs={inputrefs}
                                label='Active'
                                checked={formData.active}
                                id='txtActive'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                            />
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(`/api/User/ShowUserMaster`, filterData, 'User Master')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'UserMaster'}
                handleFilter={() => {
                    getUserMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default UserMaster;